import React, { useState } from 'react'
import { Content } from './style'
import { Outlet, useNavigate } from 'react-router-dom'
import { ButtonCreate, LeftSide, OptionsButton, RightSide, SectionName, SubHeaderContainer, Tab, TabsDiv } from '../../../components/styles/subheader-style'
import orders from '../../../assets/home/orders.svg'
import steel from '../../../assets/home/steel.svg'

const tabs = [
  { path:'', image: orders, name: 'Pedidos' },
  { path:'products', image: steel, name: 'Produtos' },
]

const SteelOrdersSubHeader:React.FC = () => {
  const navigate = useNavigate()
  
  return(
    <SubHeaderContainer>
    <LeftSide>
      <SectionName>Pedidos aço</SectionName>
      <TabsDiv>
        {tabs.map((tab, index) => (
        <Tab
          key={index}
          $isFirst={index === 0}
          $isLast={index === tabs.length - 1}
          $isActive={0 === index}
          onClick={() => {
            if(index !== 0) navigate(tab.path)
          }}
        >
            <img src={tab.image} alt={`${tab.path}-icon`} />
            {tab.name}
          </Tab>
        ))}
      </TabsDiv>
    </LeftSide>
    <RightSide>
      <ButtonCreate onClick={() => navigate('/panel/steel/create')}>+ Novo pedido</ButtonCreate>
    </RightSide>
  </SubHeaderContainer>
  )
}

const SteelOrders = () => {  
  return (
    <>
      <SteelOrdersSubHeader />
      <Content>
        <Outlet />
      </Content>
    </>
  )
}

export default SteelOrders